import styled from "styled-components";



export const Container = styled.section`
.homeMainIcon {
  display: flex !important;
  width: 37%;
  min-height: 25rem;
  margin-top: 2rem;
  padding: 0 15px;

  & > img {
    min-width: 230px;
    height: auto;
  }
}

.typewriterWrapper {
  font-size: 2.2em;
  color: #be6adf;
  font-weight: 600;
}
.typewriterCursor {
  font-size: 2.4em;
  color: #b562d6;
}


@media (max-width: 925px) {
  .content {
    padding: 9rem 3rem 1rem;
    flex-wrap: wrap;
  }
  .homeMainIcon {
    justify-content: center;
    width: 60%;
  }
} 
  .wave {
    animation-name: wave;
    animation-duration: 2.1s;
    animation-iteration-count: infinite;
    transform-origin: 70% 70%;
    display: inline-block;
  }
  padding-top: 15%;
  display: flex;
  justify-content: space-between;
  gap: 8rem;
  background: rgba(0,0,0,0);
  .hero-text{
    & > p{
      font-size: 1.8rem;
    }
    h1{
      font-size: 7rem;
    }

    h3{
      color:var(--green);
      margin: 1rem 0;
    }

    
    p.small-resume {
      margin-bottom: 5rem;
    }
  }

  .button{
    margin-top: 5rem;
    padding: 1.4rem 6rem;
  }

  .hero-image{
    img{
      max-width: 500px;
    }
  }


  @media(max-width: 960px){
    display: block;
    margin-top: 15%;
    .hero-text{

      h1{
        font-size: 5rem;
      }
    }
    
    .hero-image{
      display: none;
    }
  }

  @media(max-width: 600px){
    margin-top: 25%;
  }
  @media(max-width: 480px){
    margin-top: 35%;
  }
  .content {
    margin: 0 auto;
    max-width: 1440px;
    padding: 9rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: var(--theme-color);
    text-align: left;
  }
  
  .header {
  }
  
  .title {
    padding-left: .2rem;
    font-size: 2.4rem;
  }
    
  .mainTitle {
    font-size: 2.5rem;
    word-spacing: .3rem;
  }
  
  .mainName {
    color: var(--txt-sec-darcker);
    text-transform: uppercase;
  
  }
  
  
  
`